// src/constants/productManifest.js
import { PRODUCT_CONFIGS } from '../components/products/productConfigs';

/**
 * Combined manifest of all Neuralward products and their available routes.
 * This serves as the source of truth for the AI agent to intelligently link products.
 */
export const PRODUCT_MANIFEST = {
  // Products that have dedicated Landing Pages (/products/:slug)
  landingPages: Object.keys(PRODUCT_CONFIGS).reduce((acc, key) => {
    acc[key] = {
      name: PRODUCT_CONFIGS[key].name,
      slug: key,
      path: `/products/${key}`,
      category: PRODUCT_CONFIGS[key].category,
      description: PRODUCT_CONFIGS[key].description,
    };
    return acc;
  }, {}),

  // Products that are available in the App Center (/appcenter-store/:slug)
  storeApps: {
    // These are derived from PRODUCT_CONFIGS if they have an appCenterSlug
    ...Object.keys(PRODUCT_CONFIGS).reduce((acc, key) => {
      const config = PRODUCT_CONFIGS[key];
      if (config.appCenterSlug) {
        acc[config.appCenterSlug] = {
          name: config.name,
          slug: config.appCenterSlug,
          path: `/appcenter-store/${config.appCenterSlug}`,
          category: config.category,
        };
      }
      return acc;
    }, {}),

    // Additional apps that are ONLY in the App Center (not in Landing Pages)
    'echomarks': {
      name: 'EchoMarks',
      slug: 'echomarks',
      path: '/appcenter-store/echomarks',
      category: 'Browser Extension',
      description: 'Advanced bookmarks and sessions management for power users.',
    }
  }
};

/**
 * Helper to get all products for the AI agent system prompt
 */
export const getAgentProductKnowledge = () => {
  const allProducts = {};

  // Add landing pages
  Object.values(PRODUCT_MANIFEST.landingPages).forEach(p => {
    allProducts[p.name.toLowerCase()] = {
      name: p.name,
      landingPath: p.path,
      storePath: PRODUCT_MANIFEST.storeApps[p.slug]?.path || null,
      description: p.description
    };
  });

  // Add store-only apps
  Object.values(PRODUCT_MANIFEST.storeApps).forEach(p => {
    const key = p.name.toLowerCase();
    if (!allProducts[key]) {
      allProducts[key] = {
        name: p.name,
        landingPath: null,
        storePath: p.path,
        description: p.description
      };
    } else {
      allProducts[key].storePath = p.path;
    }
  });

  return allProducts;
};
